export type GA4EventParams = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

/**
 * Track a GA4 event via the dataLayer.
 * @param eventName - The event name to track
 * @param params - Optional event parameters
 * @param isProduction - Whether we're in production mode (pass from useClientConfig)
 */
export function trackGAEvent(eventName: string, params?: GA4EventParams, isProduction = true) {
  if (typeof window === 'undefined') {
    return;
  }

  const payload = { event: eventName, ...params };

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push(payload);

  if (!isProduction) {
    console.warn('[GA4] event', payload);
  }
}
